import {Injectable} from '@angular/core';
import {Http, Headers, Response, RequestOptionsArgs} from '@angular/http';
import {Router, ActivatedRoute} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import {tap} from "rxjs/operators/tap";
import {HttpRequestService} from '../_common/http-request.service';

@Injectable()
export class UserService {
    constructor(private http: HttpRequestService, private router: Router) {
    }

    gets(parameters) {
        return this.http.get('user', parameters)
            .map(res => {
                return res.json();
            })
    }

    add(model: any) {

        return this.http.post('user/add', model).map(res => {
            return res.json();
        });
    }

    resetPassword(model: any) {
        return this.http.put('user/reset', model)
            .map(res => {
                return res.json();
            });
    }

    changePassword(model: any) {
        return this.http.put('user/changepassword', model)
            .map(res => {
                return res.json();
            });
    }

    register(parameter: any) {
        return this.http.post('register', parameter)
            .pipe(
                tap(res => res)
            );
    }

    forgot(parameter: any) {
        return this.http.post('forgot', parameter)
            .pipe(
                tap(res => res)
            );
    }

    confirmForgot(parameter: any) {
        return this.http.post('confirm-forgot', parameter)
            .pipe(
                tap(res => res)
            );
    }

    changePwdForgot(parameter: any) {
        return this.http.post('change-password/forgot', parameter)
            .pipe(
                tap(res => res)
            );
    }

    //get profile user
    getProfileUser(parameter) {
        return this.http.get('profile-user' + this.parseParamToString(parameter))
            .pipe(
                tap(res => res)
            );
    }

    changePasswordProfile(model: any) {
        return this.http.put('user/change-password', model)
            .map(res => {
                return res.json();
            });
    }

    //convert data param to query string
    parseParamToString(param: any) {
        let queryString = `?`;
        for (var property in param) {
            if (param.hasOwnProperty(property)) {
                queryString += `&${property}=${param[property]}`;
            }
        }
        return queryString;
    }

    updateIsAdminApproved(model: any) {
        return this.http.put(`updateIsAdminApproved`, model)
            .map(res => {
                return res.json();
            });
    }

    //get all modules is active
    getAllModules() : any{
        return this.http.get(`getAllModuleIsActive`)
            .map(res => {
                return res.json()
            });
    }

    //user change module
    userUpdateModule(model: any) {
        return this.http.post(`userUpdateModule/web`, model).map(res => {
            return res.json();
        });
    }
}


// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_services/user.service.ts